import { DecisionTree } from '@/components/decision-tree';
import HeaderEditAnswer from '@/components/header-edit-answer/header-edit-answer';
import { ROUTE_TESTING_PLAN } from '@/constants/routes';
import { useNavigate } from 'react-router-dom';
import useCompleteTestController from './complete-test.controller';

export default function CompleteTest() {
  const navigate = useNavigate();
  const { userQuestionnaire, handleSaveQuestion } = useCompleteTestController();
  if (!userQuestionnaire) return null;

  function onCloseClick() {
    navigate(ROUTE_TESTING_PLAN);
  }

  return (
    <DecisionTree
      userQuestionnaire={userQuestionnaire}
      callback={handleSaveQuestion}
      header={(props) => (
        <HeaderEditAnswer
          onBackClick={props.onBackClick}
          showBackButton={props.showBackButton}
          onCloseClick={onCloseClick}
        />
      )}
    />
  );
}
